import { Description, Divider, Svg, Table, TableCell } from '@repo/ui';

import { ResultTableRow } from '@/components/tax-refund/apply/result/ResultTableRow';
import ApplyResultFaqView from '@/components/tax-refund/common/view/ApplyResultFaqView';
import { ApplyResultData } from '@/lib/types/request';
import { formatAccountBankNo } from '@/lib/utils/stringFormat';

export const ApplyResultPayCompleteContent = ({ data }: { data: ApplyResultData }) => {
  const isCorps = data.businessType === 'corps';
  const displayName = isCorps ? (data.fullName ?? data.name) : data.name;
  const title = isCorps ? `’${displayName}’의 법인세 환급 여정이 완료됐어요!` : `${data.name}님의 종합소득세\n환급 여정이 완료됐어요!`;
  const amountLabel = isCorps ? '법인세 결정 환급액' : '종합소득세 결정 환급액';
  const faqContents = isCorps
    ? [
        {
          title: '이용료에 대해 세금계산서를 발행하고 싶어요.',
          content: '이용료에 대한 세금계산서는 환급이 완료될 때 자동으로 발행되었습니다.'
        }
      ]
    : [
        {
          title: '현금영수증은 어떻게 발급하나요?',
          content:
            '계좌 입금이 완료되면 자진번호로 현금영수증을 발급한 후 카카오톡 알림톡으로 발급 정보를 전달해드립니다. 홈택스에서 발급정보로 현금영수증을 등록해주세요.'
        },
        {
          title: '자진발급된 현금영수증은 어떻게 등록하나요?',
          content:
            '자진발급된 현금영수증은 홈택스에서 자진발급된 다음 날부터 아래 방법으로 등록할 수 있어요.\n[홈택스 로그인] > [조회/발급] > [현금영수증 수정] > [자진발급분 소비자 등록] > [승인번호/거래일자/금액 입력 후 조회] > [등록]'
        },
        {
          title: '이용료에 대해 세금계산서를 발행하고 싶어요.',
          content: '비즈넵 환급에서는 모든 건에 대해 현금영수증을 자진발급하고 있습니다. 자진발급된 현금영수증은 홈택스에 등록하실 수 있어요.'
        }
      ];

  return (
    <div>
      <div className={'px-4.5 py-normal-small'}>
        <Description
          title={title}
          size={'medium'}
          description={'신규 환급금이 생기면 다시 안내드릴게요.'}
          graphic={<Svg src="icg_moneybag-check_md.svg" width={80} height={80} />}
        />
      </div>
      <Divider size={'large'} />
      <div className={'px-4.5 py-tiny-large'}>
        <div className={'pb-normal-large'}>
          <div className={'body-large-regular text-neutral-foreground-low pt-normal-large'}>{amountLabel}</div>
          <div className={'text-neutral-foreground-main heading-medium-bold'}>{data.refundAmount}</div>
          <Divider className={'my-normal-medium'} />
          <ResultTableRow label={'환급 신청일'} value={data.applyDate} />
          <ResultTableRow label={'환급 결정일'} value={data.resultDate} />
          {!isCorps && <ResultTableRow label={'입금 예정일'} value={data.depositExpectDate} />}
          <ResultTableRow label={'환급 계좌'} value={formatAccountBankNo(data.applicationInfo?.bank, data.applicationInfo?.accountNo)} />
          <ResultTableRow label={'결제 완료일'} value={data.paymentDate} />
          <Table
            headerCell={<TableCell variant={'header'}>결제 금액</TableCell>}
            contentCell={
              <TableCell className={'flex-1 text-right'}>
                {data.paymentAmount === '' ? '확인중...' : <span className={'font-bold'}>{data.paymentAmount}</span>}
              </TableCell>
            }
          />
        </div>
      </div>
      <Divider size={'large'} />
      <ApplyResultFaqView data={faqContents} clickEventName={isCorps ? 'corps-result_faq_complete-payment' : 'indis-result_faq_complete-payment'} />
      <div className={'pb-normal-medium'} />
    </div>
  );
};
